import { Text } from '@/components/gluestack/text';
import { Button, ButtonText } from '@/components/gluestack/button';
import { Card } from '@/components/gluestack/card';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { SquareArrowExpand01Icon } from '@hugeicons-pro/core-stroke-rounded';
import { StartUp02Icon } from '@hugeicons-pro/core-solid-rounded';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import { router } from 'expo-router';

export const PostCardUpgrade: React.FC = () => {
  const { t } = useTranslation();

  const handleUpgrade = () => {
    router.navigate('/account/plans');
  };

  return (
    <Card size="md" className="bg-primary-200">
      <View className="mb-2 items-center">
        <HugeIconsWrapper
          icon={SquareArrowExpand01Icon}
          size={48}
          className="text-primary-400"
        />
      </View>
      <Text className="mb-4 text-center font-medium">
        {t('upgrade.prompt')}
      </Text>

      <View className="flex-row justify-center">
        <Button onPress={handleUpgrade} className="px-8">
          <HugeIconsWrapper icon={StartUp02Icon} className="mr-2 color-white" />
          <ButtonText variant="solid" action="primary">
            {t('upgrade.upgrade_button')}
          </ButtonText>
        </Button>
      </View>
    </Card>
  );
};
